import { ChainID } from '@ankr.com/chains-list';

import { getChainGroups } from 'modules/endpoints/constants/groups';
import { isGroupEvmBased } from 'modules/endpoints/utils/isGroupEvmBased';

import { isBeacon } from './isBeacon';
import { isOpnode } from './isOpnode';

export const isEVMBased = (chainID: ChainID) =>
  getChainGroups()
    .filter(isGroupEvmBased)
    .some(({ chains }) => chains.includes(chainID)) &&
  !isBeacon(chainID) && // all beacons are non evm
  !isOpnode(chainID); // all opnodes are non evm
